import { useEffect, useState } from "react";
import { TextField, Button, Box, Stack, useMediaQuery } from "@mui/material";
import AppBarExplorer from "../../components/AppBar/Explorer";
import FloweringTime from "../../components/Explorer/Plant/FloweringTime";
import Native from "../../components/Explorer/Plant/Native";
import Category from "../../components/Explorer/Plant/Category";
import Sunlight from "../../components/Explorer/Plant/Sunlight";
import { Typography } from "@mui/material";
import { Divider } from "@mui/material";
import { uploadDataWithName } from "../../libs/firebase/firestore/uploadDataWithName";
import { getData } from "../../libs/firebase/firestore/getData";
import { updateData } from "../../libs/firebase/firestore/updateData";
import Soil from "../../components/Explorer/Plant/Soil";
import Water from "../../components/Explorer/Plant/Water";
import { useTheme } from "@emotion/react";
// import { db } from "../../firebase";

export default function ExporerCreatePlant() {
  const [formData, setFormData] = useState({
    name: "",
    genus: "",
    height: "",
    width: "",
    flowerColor: "",
    floweringTime: [],
    plantImage: "",
    flowerImage: "",
    category: "",
    isNative: false,
    sunlight: [],
  });

  // state to hold plants
  const [plants, setPlants] = useState([]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    uploadDataWithName(
      formData,
      "plants",
      formData.name,
      () => {
        // update the plants state
        let newPlants = [...plants, formData.name];
        setPlants(newPlants);

        // update plant information on firebase
        updateData(
          {
            names: newPlants,
          },
          "plants",
          "all",
          () => {},
          (error) => {
            console.log(error);
          }
        );

        alert("Plant information submitted successfully!");
        setFormData({
          name: "",
          genus: "",
          height: "",
          width: "",
          flowerColor: "",
          floweringTime: [],
          plantImage: "",
          flowerImage: "",
          category: "",
          isNative: false,
          sunlight: [],
        });
        window.location.reload();
      },
      (error) => {
        console.error("Error submitting plant information: ", error);
        alert("Error submitting plant information. Please try again later.");
      }
    );
  };
  useEffect(() => {
    // get the plants from firebase
    getData(
      "plants/all",
      (data) => {
        setPlants(data.names);
      },
      (error) => {
        console.log(error);
      }
    );
  }, []);

  // if brekapoint is below sx

  const theme = useTheme();
  const isXsBreakPoint = useMediaQuery(theme.breakpoints.down("sm"));

  const width = isXsBreakPoint ? "100%" : "50%";

  return (
    <Box>
      <AppBarExplorer />
      <Box
        style={{
          padding: "2rem",
          display: "flex",
          flexDirection: "column",
          width: width,
          margin: "auto",
        }}
      >
        {/* Title and subtitle */}
        <Typography variant="h5">Explorer</Typography>
        <Typography variant="subtitle1">Add a plant</Typography>

        <Divider
          sx={{
            my: 2,
          }}
        />

        <form onSubmit={handleSubmit}>
          <Stack
            spacing={2}
            style={{
              //   padding: "2rem",
              margin: "auto 0",
            }}
          >
            <TextField
              name="name"
              label="Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <TextField
              name="genus"
              label="Genus"
              value={formData.genus}
              onChange={handleChange}
              required
            />

            <Category
              value={formData.category}
              onChange={(value) =>
                setFormData((prevFormData) => ({
                  ...prevFormData,
                  category: value,
                }))
              }
            />

            <Native
              isNative={formData.isNative}
              onChange={handleChange}
              required
            />
            <TextField
              name="height"
              label="Height (m)"
              value={formData.height}
              onChange={handleChange}
              required
            />
            <TextField
              name="width"
              label="Width (m)"
              value={formData.width}
              onChange={handleChange}
              required
            />
            <Water
              value={formData.water}
              onChange={(value) =>
                setFormData((prevFormData) => ({
                  ...prevFormData,
                  water: value,
                }))
              }
              required
            />
            <TextField
              name="flowerColor"
              label="Flower Color"
              value={formData.flowerColor}
              onChange={handleChange}
            />
            <FloweringTime
              value={formData.floweringTime}
              onChange={(value) =>
                setFormData((prevFormData) => ({
                  ...prevFormData,
                  floweringTime: value,
                }))
              }
            />
            <Sunlight
              value={formData.sunlight}
              onChange={(value) =>
                setFormData((prevFormData) => ({
                  ...prevFormData,
                  sunlight: value,
                }))
              }
              required
            />
            <Soil
              value={formData.soil}
              onChange={(value) =>
                setFormData((prevFormData) => ({
                  ...prevFormData,
                  soil: value,
                }))
              }
              required
            />

            <TextField
              name="plantImage"
              label="Plant Image"
              value={formData.plantImage}
              onChange={handleChange}
              required
            />
            <TextField
              name="flowerImage"
              label="Flower Image"
              value={formData.flowerImage}
              onChange={handleChange}
            />
            <Button
              variant="contained"
              disabled={
                !formData.name ||
                !formData.genus ||
                !formData.category ||
                !formData.height ||
                !formData.width ||
                // !formData.flowerColor ||
                // !formData.floweringTime ||
                !formData.plantImage ||
                // !formData.flowerImage ||
                !formData.sunlight
              }
              type="submit"
            >
              Submit
            </Button>
          </Stack>
        </form>
      </Box>
    </Box>
  );
}
